import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Container, Col, Row, Button} from "reactstrap";
import "../vodafone.css"
import iconTechnicianRed from "../media/icons/technician-red.png"
import iconTechnicianWhite from "../media/icons/technician-white.png"
import {parseKasBarcodeFromUrl} from "../api/common";
import {BrowserView,MobileView,isMobile} from "react-device-detect";

/**
 * Top Navigation
 */
class HomescreenButton extends React.Component {

    /**
     * Constructor
     * @param props
     */
    constructor(props){
        super(props);
        // console.log("Test: "+ props );
    }



    /**
     * render
     * @returns {*}
     */
    render() {

        // Mobile View
        if( isMobile ) {

            return <Col className={'ml-auto homescreenButtonX'}>
                <Row>
                    <Col xs={12}>
                        <div className={"homescreenButton"} onClick={this.props.buttonOnClick}><div>{i18n.t(this.props.buttonTextResource, this.props)}&nbsp;<span className={'infobubble ng-isolate-scope tooltipster tooltipstered'}></span></div></div>
                    </Col>
                </Row>
            </Col>;

        // Browser View
        } else {
            return <Col md={{size: 2, offset: 9}} xs={{size: 2, offset: 7}} className={'homescreenButtonX'}>
                <Row>
                    <Col xs={12}>
                        <div className={"homescreenButton"} onClick={this.props.buttonOnClick}><div>{i18n.t(this.props.buttonTextResource, this.props)}&nbsp;<span className={'infobubble ng-isolate-scope tooltipster tooltipstered'}></span></div></div>
                    </Col>
                </Row>
            </Col>;

        }

    }
}

export default translate("translations")(HomescreenButton);